<template>
  <div v-if="website.id" class="ba-w-100 ba-grid ba-gp-08">
    <form v-if="website" class="ba-w-100 ba-grid ba-gp-08">
      <div class="ba-grid ba-w-100 ba-gp-08">
        <div>
          <ace-code-editor editorId="script" :content="website.layout.script.script" config="script"
            @change-content="changeScript" height="240" />
          <br>
          <div class="ba-w-100 ba-flex ba-ai-center ba-gp-06">
            <!-- <label class='ba-switch ba-sm' @click="enableSyncScript"> -->
            <label class='ba-switch ba-sm'>
                <input type='checkbox' class='ba-checkbox' v-model="website.layout.script.script_sync" :true-value=1 :false-value=0 >
                <span class='ba-slider'></span>
            </label>
            <label v-text="$t('ct-enable-synchronous-script')" />
          </div>
        </div>
        <alert-box-component type="warning" :with_icon="true">
          <p slot="content" v-text="$t('ct-sync-script')" />
        </alert-box-component>
      </div>
      <hr class="ba-hr-row">
      <div class="ba-w-100 ba-grid ba-gp-08">
        <span class="ba-custom-label" v-text="$t('ct-pixel-settings')" />
        <div class="ba-w-100 ba-flex ba-gp-08">
          <div class="ba-grid ba-w-50">
            <label for="facebook" class="ba-custom-label">Facebook</label>
            <input type="text" id="facebook" class="ba-input ba-md" placeholder="Pixel ID - exemplo: 1484257648798990"
              v-model="website.layout.configuration.facebook_pixel" />
          </div>
          <div class="ba-grid ba-w-50">
            <label for="facebook" class="ba-custom-label">Facebook Api Token</label>
            <input type="text" id="facebook" class="ba-input ba-md" placeholder="Facebook Api token"
              v-model="website.layout.configuration.facebook_pixel_token" />
          </div>
        </div>
        <div class="ba-w-100 ba-flex ba-gp-08">
          <div class="ba-grid ba-w-50">
            <label for="google_analytics" class="ba-custom-label"> Google Analytics</label>
            <input type="text" id="google_analytics" class="ba-input ba-md" placeholder="Pixel ID - exemplo: G-ABC123XYZ"
              v-model="website.layout.configuration.google_analytics" />
          </div>
          <div class="ba-grid ba-w-50">
            <label for="google_tag_manager" class="ba-custom-label">Google TAG Manager</label>
            <input type="text" id="google_tag_manager" class="ba-input ba-md" placeholder="Pixel ID - exemplo: GTM-PR97GW6"
              v-model="website.layout.configuration.google_tag_manager" />
          </div>
        </div>
        <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
          <button @click="addEvent()" class="ba-btn ba-md ba-blue">
            <builderall-icon code='2780'></builderall-icon>
            {{ $t('ct-pixel-event-add') }}
          </button>
        </div>
        <div class="ba-w-100">
          <alert-box-component type="warning">
            <p slot="content" style="width: 100%" v-text="'- ' + $t('ct-facebook-api-test')" />
            <br>
            <p slot="content" style="width: 100%" v-text="'- ' + $t('ct-facebook-one-event-whitout-api')" />
          </alert-box-component>
          <div v-for="(event, index) in events" :key="index" class="split-test-row d-flex mt-3">
            <div data-v-3ef0d2f0="" class="split-test-variant-row d-inline-flex w-100">
              <div data-v-3ef0d2f0="" class="place-page ba-w-100 ba-flex ba-ai-center ba-jc-sb">
                {{ $t('ct-origin-url') }} : {{ event.url_origin }} | {{ event.event !== '' ?
                  `${$t('ct-pixel-custom-event')} : ${event.event}` : `${$t('ct-pixel-standard-event')} :
                ${event.standard_event}` }}
                <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="deleteEvent(index)">
                  <builderall-icon code='trash' />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
      <button type="button" @click.prevent="saveSettings(website)" data-ba-i="seo-settings"
        class="ba-btn ba-md ba-blue">
        {{ $t('ct-save') }}
      </button>
    </div>

    <sweet-modal width="60vw" ref="modal-add-event" hide-close-button>
      <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
        <h5 class="ba-color-blue1">{{ $t('ct-pixel-event-add') }}</h5>
        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closePopupEvent">
          <builderall-icon code='64f7' />
        </button>
      </div>
      <hr class='ba-hr-row'>
      <div class="ba-grid ba-mg-y-1 ba-grid ba-gp-08">
        <div class="ba-grid">
          <label for="" class="ba-custom-label">{{ $t('ct-select-a-page') }}</label>
          <select class="ba-select ba-md" v-model="my_event.url_origin">
            <option value="">{{ $t('ct-select') }}</option>
            <option v-for="(page, index) in pages" :key="index" :value="page.url">{{ page.name }}
            </option>
          </select>
          <!-- <input v-model="my_event.url_origin" type="text" :placeholder="$t('ct-origin-url-plh')" class="form-control"> -->
        </div>
        <div class="ba-grid">
          <label for="" class="ba-custom-label">{{ $t('ct-pixel-custom-event') }}</label>
          <input v-model="my_event.event" type="text" class="ba-input ba-md">
        </div>
        <div class="ba-grid">
          <label class="ba-custom-label">{{ $t('ct-pixel-standard-event') }}</label>
          <select class="ba-select ba-md" v-model="my_event.standard_event" :disabled="standardEvent">
            <option value="" :selected="standardEvent">{{ $t('ct-select') }}</option>
            <option v-for="event, index in standardEvents" :key="index" :value="event.value">{{ event.text }}
            </option>
          </select>
        </div>
        <div v-if="my_event.standard_event == 'Purchase'" class="form-group row">
          <div class="form-group col-6">
            <label for="">{{ `${$t('ct-currency')} *` }}</label>
            <select class="form-control" v-model="my_event.purchase_event_info.currency"
              :class="{ 'is-invalid': errors.has('purchase_event_info.currency') }"
              @change="errors.clear('purchase_event_info.currency')">
              <option value="">{{ $t('ct-select') }}</option>
              <option v-for="(currency, index) in currencies" :key="index" :value="currency.code">{{ currency.code }}
              </option>
            </select>
            <span v-if="errors.has('purchase_event_info.currency')" class="invalid-feedback"
              v-text="errors.get('purchase_event_info.currency')"></span>
          </div>
          <div class="form-group col-6">
            <label for="">{{ `${$t('ct-value')} *` }}</label>
            <input v-model="my_event.purchase_event_info.value" @keyup="errors.clear('purchase_event_info.value')"
              @change="errors.clear('purchase_event_info.value')" type="number" class="form-control"
              :class="{ 'is-invalid': errors.has('purchase_event_info.value') }">
            <span v-if="errors.has('purchase_event_info.value')" class="invalid-feedback"
              v-text="errors.get('purchase_event_info.value')"></span>
          </div>
        </div>
        <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
          <button slot="button" class="ba-btn ba-md ba-light" @click="closePopupEvent">
            {{ $t('ct-cancel') }}
          </button>
          <button type="button" class="ba-btn ba-md ba-blue" @click.prevent="addEventOnArray()">
            {{ $t('ct-save') }}
          </button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>

import AlertBoxComponent from '../../commons/AlertBoxComponent';
import ToggleButtonComponent from '../../commons/ToggleButtonComponent';
import { SweetModal } from 'sweet-modal-vue';

import {
  get as getWebsite,
  editScripts
} from '../../../js/services/editor/website';
import Errors from '../../../js/base/Errors';
import AceCodeEditor from "../components/AceCodeEditor";
import currencies from "@/assets/currencies.json";
export default {
  name: 'WebsiteScripts',
  components: {
    AlertBoxComponent,
    ToggleButtonComponent,
    SweetModal,
    AceCodeEditor
  },
  data() {
    return {
      currencies: currencies,
      errors: new Errors(),
      website: {},
      scriptLayout: {
        script: '',
        script_pixel: '',
        script_analytics: ''
      },
      my_event: {
        url_origin: '',
        event: '',
        standard_event: '',
        purchase_event_info: {
          value: 0,
          currency: ''
        }
      },
      events: [],
      pages: [],
      standardEvents: [
        { text: 'Add payment info', value: 'AddPaymentInfo' },
        { text: 'Add to cart', value: 'AddToCart' },
        { text: 'Add to wishlist', value: 'AddToWishlist' },
        { text: 'Complete registration', value: 'CompleteRegistration' },
        { text: 'Contact', value: 'Contact' },
        { text: 'Customize product', value: 'CustomizeProduct' },
        { text: 'Donate', value: 'Donate' },
        { text: 'Find location', value: 'FindLocation' },
        { text: 'Initiate checkout', value: 'InitiateCheckout' },
        { text: 'Lead', value: 'Lead' },
        { text: 'Purchase', value: 'Purchase' },
        { text: 'Schedule', value: 'Schedule' },
        { text: 'Search', value: 'Search' },
        { text: 'Start trial', value: 'StartTrial' },
        { text: 'Submit application', value: 'SubmitApplication' },
        { text: 'Subscribe', value: 'Subscribe' },
        { text: 'View content', value: 'ViewContent' }
      ],
      standardEvent: false
    };
  },
  watch: {
    'my_event.event': {
      handler: function (val) {
        if (val !== '') {
          this.standardEvent = true;
          this.my_event.standard_event = '';
        } else {
          this.standardEvent = false;
        }
      },
      deep: true
    },
    'my_event.standard_event': {
      handler: function (val) {
        if (val !== "Purchase") {
          this.my_event.purchase_event_info.value = 0;
          this.my_event.purchase_event_info.currency = '';
        }
      },
      deep: true
    }
  },
  methods: {
    // handleChange(e) {
    //   const { value } = e.target;
    //   if (value) {
    //     this.my_event.standard_event.push(value);
    //   }
    // const { value, checked } = e.target
    // if (checked) {
    //   this.my_event.standard_event.push(value);
    //   console.log(this.my_event)
    // } else {
    //    const index = this.my_event.standard_event.findIndex(id => id === value)
    //   if (index > -1) {
    //     this.my_event.standard_event.splice(index, 1)
    //   }
    // }
    // },
    addEvent() {
      this.my_event = {
        url_origin: '',
        event: '',
        standard_event: '',
        purchase_event_info: {
          value: 0,
          currency: ''
        }
      },
        this.$refs['modal-add-event'].open();
    },
    closePopupEvent() {
      this.$refs['modal-add-event'].close();
    },
    deleteEvent(index) {
      this.events.splice(index, 1)
      this.$snotify.success(this.$t('ct-success-true'));

    },
    addEventOnArray() {

      if (this.my_event.url_origin == '') {
        this.$snotify.error(this.$t('ct-select-a-page'));
        return;
      }
      if (this.my_event.event == '' && this.my_event.standard_event == '') {
        this.$snotify.error(this.$t('ct-select-or-insert-an-event'));
        return;
      }
      if (this.my_event.standard_event == 'Purchase') {
        this.my_event.purchase_event_info.value = parseInt(this.my_event.purchase_event_info.value);
        const { value, currency } = this.my_event.purchase_event_info;

        if (currency == '') {
          this.errors.add('currency', 'is-required', 'purchase_event_info');
          return;
        } else if (isNaN(value) || value < 0) {
          this.errors.add('value', 'is-required', 'purchase_event_info');
          return;
        }
      }
      this.events.push({ url_origin: this.my_event.url_origin.trim().toLowerCase(), event: this.my_event.event.trim(), standard_event: this.my_event.standard_event, purchase_event_info: { value: this.my_event.purchase_event_info.value, currency: this.my_event.purchase_event_info.currency } })

      this.my_event.url_origin = '';
      this.my_event.event = '';
      this.my_event.standard_event = '';
      this.my_event.purchase_event_info = {
        value: 0,
        currency: ''
      }

      this.events.sort(function (a, b) {
        return (a.url_origin > b.url_origin) ? 1 : ((b.url_origin > a.url_origin) ? -1 : 0);
      })

      this.$refs['modal-add-event'].close()
      this.$snotify.success(this.$t('ct-success-true'));

    },
    redirectSeoRoute() {
      this.$router.push({
        name: 'GeneralSettings',
        params: { id: this.website.encrypted_id }
      });
    },
    enableSyncScript(value) {
      this.website.layout.script.script_sync = +value;
    },
    changeScript(value, config) {
      this.website.layout.script[config] = value;
    },
    saveSettings(website) {
      this.$loading.show();

      if (!this.errors.any()) {
        website.events = JSON.stringify(this.events);

        editScripts(website)
          .then(data => {
            this.$snotify.success(this.$t('ct-success-true'));
          })
          .catch(response => {
            if (response.response && response.response.data) { this.errors.record({ website: response.response.data.errors }) }

            this.$snotify.success(this.$t('ct-success-false'));
          })
          .finally(() => this.$loading.hide());
      } else {
        this.$loading.hide();
      }
    }
  },

  async created() {
    this.$loading.show();

    getWebsite(this.$route.params.id)
      .then(website => {
        this.website = website.data;
        if (this.website.pixel !== null) {
          this.events = JSON.parse(this.website.pixel.content)
          this.events.sort(function (a, b) {
            return (a.url_origin > b.url_origin) ? 1 : ((b.url_origin > a.url_origin) ? -1 : 0);
          })
        }
        this.website.layout = this.website.layouts[0];
        this.pages = this.website.layouts[0].pages;
        if (this.website.layout.script === null) { this.website.layout.script = this.scriptLayout }

        if (this.website.layout.configuration === null) {
          this.website.layout.configuration = {
            favicon: '',
            keyword: '',
            metatag: ''
          };
        }
      })
      .finally(() => this.$loading.hide());
  }
};
</script>

<style lang="scss" scoped>
.sweet-modal .sweet-content .form-group .form-control {
  border-radius: 3px;
  height: 47px;
  font-family: Lato;
  color: #656565;

  &:not(.is-valid):not(.is-invalid) {
    border: 1px solid #DDDDDD;
  }
}

.labelspacing {
  padding-left: 30px;
  padding-right: 60px;
}

.left {
  left: 30px;
}

.website-scripts {
  &__header {
    h1 {
      font-family: 'Muli', sans-serif;
      font-size: 25px;
      font-weight: bold;

      color: #0080FC;
    }
  }

  .card {
    margin-top: 15px;

    &-header {
      font-family: 'Muli', sans-serif;
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;

      color: #333333;
      background-color: #F7F7F7;

      box-shadow: 0px 6px 3px #7E7E7E10;
      padding: 24px 32px;
    }

    &-body {
      .enable-sync-script {
        margin-bottom: 16px;

        span {
          font-family: 'Muli', sans-serif;
          font-size: 11px;
          font-weight: bold;
          color: #5A5959;

          margin-left: 5px;
        }
      }
    }
  }

  .pixel-settings {
    border-top: #D1D2D2 2px solid;
    margin: 0;

    h2 {
      font-family: 'Muli', sans-serif;
      font-size: 20px;
      font-weight: bold;

      color: #333333;

      margin: 25px 0px 22px 0px;
    }

    &__illustration {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 440px;
      margin-left: 80px;

      img {
        width: 100%;
      }
    }

    .form-group {
      label {
        font-family: 'Muli', sans-serif;
        font-size: 16px;
        color: #5A5959;
      }

      input {
        height: 46px;

        font-family: 'Muli', sans-serif;
        font-size: 13px;

        color: #656565;
        background: #FAFBFC;
        border-color: #E0E0E0;

        transition: all 0.2s;

        &:focus {
          outline: none;
          border-color: #0080FC;
          box-shadow: none;
        }
      }
    }
  }
}


.split-test-row {

  .btn-add-page {
    position: absolute;
    top: 30px;
    right: 30px;
  }

  .header-text {
    font-family: 'Muli', sans-serif;
    font-size: 18px;
    font-weight: bold;

    color: #0080FC;

    &.variation-text {
      margin-top: 10px;
      font-size: 18px;
      color: #040404;
      font-weight: 500;
    }
  }

  .place-page {
    background: #FAFBFC 0% 0% no-repeat padding-box;
    border: 1px solid #DDDDDD;
    border-radius: 6px;
    opacity: 1;
    padding: 18px;
    margin-bottom: 15px;
  }

  .icon-delete {
    font-size: 20px;
    color: red;
    cursor: pointer;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/views/WebsiteScripts.vue